export const CATEGORY_IMAGE_FALLBACKS = {
  Pizza: 'https://images.unsplash.com/photo-1513104890138-7c749659a591?w=300',
  Hamburguer: 'https://images.unsplash.com/photo-1568901346375-23c9450c58cd?w=300',
  Japones: 'https://images.unsplash.com/photo-1579871494447-9811cf80d66c?w=300',
  Italiana: 'https://images.unsplash.com/photo-1621996346565-e3dbc646d9a9?w=300',
  Brasileira: 'https://images.unsplash.com/photo-1551504734-5ee1c4a1479b?w=300',
  Saudavel: 'https://images.unsplash.com/photo-1498837167922-ddd27525d352?w=300',
  Doces: 'https://images.unsplash.com/photo-1488477181946-6428a0291777?w=300',
  Bebidas: 'https://images.unsplash.com/photo-1544145945-f90425340c7e?w=300',
  Mercado: 'https://images.unsplash.com/photo-1542838132-92c53300491e?w=300',
  Conveniencia: 'https://images.pexels.com/photos/264636/pexels-photo-264636.jpeg?auto=compress&cs=tinysrgb&w=300',
  Padaria: 'https://images.unsplash.com/photo-1509440159596-0249088772ff?w=300',
  Salgados: 'https://images.pexels.com/photos/2762939/pexels-photo-2762939.jpeg?auto=compress&cs=tinysrgb&w=300',
  Lanchonete: 'https://images.unsplash.com/photo-1555396273-367ea4eb4db5?w=300',
  'Frutos do Mar': 'https://images.pexels.com/photos/3296280/pexels-photo-3296280.jpeg?auto=compress&cs=tinysrgb&w=300',
  Vegana: 'https://images.unsplash.com/photo-1512621776951-a57141f2eefd?w=300',
  Mexicana: 'https://images.unsplash.com/photo-1618040996337-56904b7850b9?w=300',
  Arabe: 'https://images.pexels.com/photos/1618906/pexels-photo-1618906.jpeg?auto=compress&cs=tinysrgb&w=300',
  Chinesa: 'https://images.unsplash.com/photo-1526318896980-cf78c088247c?w=300',
  Outro: 'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=300',
};

export const OFFLINE_CATEGORIES = [
  { id: 1, name: 'Pizza', image_url: CATEGORY_IMAGE_FALLBACKS.Pizza, icon: '' },
  { id: 2, name: 'Hamburguer', image_url: CATEGORY_IMAGE_FALLBACKS.Hamburguer, icon: '' },
  { id: 3, name: 'Japones', image_url: CATEGORY_IMAGE_FALLBACKS.Japones, icon: '' },
  { id: 4, name: 'Italiana', image_url: CATEGORY_IMAGE_FALLBACKS.Italiana, icon: '' },
  { id: 5, name: 'Brasileira', image_url: CATEGORY_IMAGE_FALLBACKS.Brasileira, icon: '' },
  { id: 6, name: 'Saudavel', image_url: CATEGORY_IMAGE_FALLBACKS.Saudavel, icon: '' },
  { id: 7, name: 'Doces', image_url: CATEGORY_IMAGE_FALLBACKS.Doces, icon: '' },
  { id: 8, name: 'Bebidas', image_url: CATEGORY_IMAGE_FALLBACKS.Bebidas, icon: '' },
  { id: 9, name: 'Mercado', image_url: CATEGORY_IMAGE_FALLBACKS.Mercado, icon: '' },
  { id: 10, name: 'Conveniencia', image_url: CATEGORY_IMAGE_FALLBACKS.Conveniencia, icon: '' },
  { id: 11, name: 'Padaria', image_url: CATEGORY_IMAGE_FALLBACKS.Padaria, icon: '' },
  { id: 12, name: 'Salgados', image_url: CATEGORY_IMAGE_FALLBACKS.Salgados, icon: '' },
  { id: 13, name: 'Lanchonete', image_url: CATEGORY_IMAGE_FALLBACKS.Lanchonete, icon: '' },
  { id: 14, name: 'Frutos do Mar', image_url: CATEGORY_IMAGE_FALLBACKS['Frutos do Mar'], icon: '' },
  { id: 15, name: 'Vegana', image_url: CATEGORY_IMAGE_FALLBACKS.Vegana, icon: '' },
  { id: 16, name: 'Mexicana', image_url: CATEGORY_IMAGE_FALLBACKS.Mexicana, icon: '' },
  { id: 17, name: 'Arabe', image_url: CATEGORY_IMAGE_FALLBACKS.Arabe, icon: '' },
  { id: 18, name: 'Chinesa', image_url: CATEGORY_IMAGE_FALLBACKS.Chinesa, icon: '' },
  { id: 19, name: 'Outro', image_url: CATEGORY_IMAGE_FALLBACKS.Outro, icon: '' },
];

const normalizeCategoryToken = (value) =>
  String(value || '')
    .trim()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9 ]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

const CATEGORY_ALIASES = {
  Pizza: ['pizza', 'pizzaria'],
  Hamburguer: ['hamburguer', 'hamburger', 'hamburgueria', 'burger', 'lanches'],
  Japones: ['japones', 'japonesa', 'sushi', 'temaki'],
  Italiana: ['italiana', 'italiano', 'massas', 'massa', 'macarrao'],
  Brasileira: ['brasileira', 'brasileiro', 'comida brasileira'],
  Saudavel: ['saudavel', 'saude', 'fit', 'natural'],
  Doces: ['doces', 'doce', 'sobremesa', 'sobremesas', 'confeitaria'],
  Bebidas: ['bebidas', 'bebida', 'drink', 'drinks', 'exodo', 'ex do', 'exdo', 'xodo'],
  Mercado: ['mercado', 'mercados', 'supermercado', 'mercearia'],
  Conveniencia: ['conveniencia', 'conveniencia 24h', 'conveniencia 24 h'],
  Padaria: ['padaria', 'padoca', 'panificadora'],
  Salgados: ['salgados', 'salgado'],
  Lanchonete: ['lanchonete', 'lanche', 'lanches'],
  'Frutos do Mar': ['frutos do mar', 'fruto do mar', 'peixes', 'mariscos'],
  Vegana: ['vegana', 'vegano', 'vegan'],
  Mexicana: ['mexicana', 'mexicano', 'taco', 'nacho'],
  Arabe: ['arabe', 'arabes', 'esfiha', 'kibe'],
  Chinesa: ['chinesa', 'chines', 'yakisoba'],
  Outro: ['outro', 'restaurante', 'restaurantes', 'restaurants'],
};

const findCanonicalCategory = (name) => {
  const token = normalizeCategoryToken(name);
  if (!token) return null;

  for (const [canonical, aliases] of Object.entries(CATEGORY_ALIASES)) {
    if (aliases.some((alias) => token === alias || token.includes(alias))) {
      return canonical;
    }
  }
  return null;
};

export const normalizeCategoryName = (name) => {
  const raw = String(name || '').trim();
  return findCanonicalCategory(raw) || raw || 'Outro';
};

const splitCategoryCandidates = (value) =>
  String(value || '')
    .split(/[|,;/]+/g)
    .map((item) => item.trim())
    .filter(Boolean);

const extractRestaurantCategories = (restaurantCategory) => {
  if (Array.isArray(restaurantCategory)) {
    return restaurantCategory.flatMap(splitCategoryCandidates);
  }

  if (restaurantCategory && typeof restaurantCategory === 'object') {
    const fromObject = [
      ...(Array.isArray(restaurantCategory.categories) ? restaurantCategory.categories : []),
      restaurantCategory.category,
    ];
    return fromObject.flatMap(splitCategoryCandidates);
  }

  if (typeof restaurantCategory === 'string') {
    return splitCategoryCandidates(restaurantCategory);
  }

  return [];
};

export const matchRestaurantCategory = (restaurantCategory, selectedCategory) => {
  const selectedCanonical = findCanonicalCategory(selectedCategory) || normalizeCategoryName(selectedCategory);
  const selectedToken = normalizeCategoryToken(selectedCategory);
  if (!selectedCanonical && !selectedToken) return false;

  const candidates = extractRestaurantCategories(restaurantCategory);
  if (candidates.length === 0) return false;

  return candidates.some((candidate) => {
    const restaurantCanonical = findCanonicalCategory(candidate) || normalizeCategoryName(candidate);
    if (selectedCanonical && restaurantCanonical && selectedCanonical === restaurantCanonical) {
      return true;
    }

    const restaurantToken = normalizeCategoryToken(candidate);
    if (!restaurantToken || !selectedToken) return false;
    return restaurantToken.includes(selectedToken) || selectedToken.includes(restaurantToken);
  });
};

export const normalizeCategoriesPayload = (list = []) =>
  list.map((item, index) => {
    const name = normalizeCategoryName(item?.name);
    return {
      ...item,
      id: item?.id ?? index + 1,
      name,
      image_url: item?.image_url || item?.image || CATEGORY_IMAGE_FALLBACKS[name] || CATEGORY_IMAGE_FALLBACKS.Outro,
      icon: item?.icon || '',
    };
  });
